import { createStyles } from "@app/components/tss/hooks/use-tss-styles";

export const useStyles = createStyles(({ theme }) => {
  const { colors, spacing } = theme.busbud;
  const supports_backdrop_filter = "@supports (backdrop-filter: blur(1px))";

  return {
    container: {
      position: "fixed",
      left: 0,
      bottom: 0,
      right: 0,
      zIndex: 2 // seats numbers have a zIndex 1
    },
    centeredContent: {
      maxWidth: "400px",
      marginLeft: "auto",
      marginRight: "auto",
      padding: spacing(2)
    },
    wrapperTotal: {
      background: colors.background.secondary.translucent,
      [supports_backdrop_filter]: {
        backdropFilter: `blur(${spacing(2)}) saturate(150%)`
      }
    },
    button: {
      marginLeft: spacing(3)
    },
    wrapperSeatSelection: {
      background: colors.background.primary.translucent,
      [supports_backdrop_filter]: {
        backdropFilter: `blur(${spacing(2)}) saturate(150%)`
      }
    }
  };
});
